import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faClock } from "@fortawesome/free-solid-svg-icons/faClock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export function ExpiresMeter({ expires_max, time_remaining, showMeter }) {
    // convince TypeScript that TimeRemainingWrapper has added the time_remaining prop
    if (time_remaining === undefined) {
        return null;
    }
    return (_jsxs("div", { className: "expires-meter", children: [_jsx("span", { className: "expires-symbol", children: _jsx(FontAwesomeIcon, { icon: faClock }) }), showMeter ? (_jsx("meter", { low: expires_max * 0.2, max: expires_max, value: time_remaining.total_seconds, id: "expires-meter" }, "0")) : null, _jsxs("span", { className: "timer", children: [time_remaining.minutes, ":", time_remaining.seconds] })] }));
}
